<template>
    <div>
        {{ extractorWarningDialogFailedFieldsMessage }}
    </div>
    <pc-expand-list
        v-bind:items="extractorFailureFields"
        use-bullets />
</template>
<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/extractorWarningDialog.i18n";

    export default {
        props: {
            extractorFailureFields: { type: Array, required: true }
        },
        computed: {
            ...mapI18n(KEYS, NAMESPACE)
        }
    };
</script>
